import(/* webpackMode: "eager", webpackExports: ["RepositoryProvider"] */ "/app/apps/tagea-web/src/app/[lang]/[tenant]/repository-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TenantProvider"] */ "/app/apps/tagea-web/src/libs/core/context/tenant-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HttpProvider"] */ "/app/apps/tagea-web/src/libs/core/http/infrastructure/client-side/http.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DictionaryProvider"] */ "/app/apps/tagea-web/src/libs/core/internationalization/dictionary.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NextRouterProvider"] */ "/app/apps/tagea-web/src/libs/core/routing/infrastructure/next-router.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/apps/tagea-web/src/libs/features/auth/main/infrastructure/auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogoProvider"] */ "/app/apps/tagea-web/src/libs/features/branding/logo/ui/logo.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/apps/tagea-web/src/libs/features/branding/theme/ui/theme.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrmzFileProvider"] */ "/app/apps/tagea-web/src/libs/features/files/trmz-file/ui/trmz-file.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LightboxProvider"] */ "/app/apps/tagea-web/src/libs/features/lightbox/lightbox.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpecializationProvider"] */ "/app/apps/tagea-web/src/libs/features/specializations/application/specialization.concern.tsx");
